import axios from 'axios';

export const baseAPIRoute = `/wp-json/api`;

export const getDevelopments = async () => {
  const result = await axios(`${baseAPIRoute}/developments`);
  return result;
};

export const getOpeningTimes = async (developmentId) => {
  const result = await axios.post(`${baseAPIRoute}/opening-times`, {
    id: developmentId,
  });
  return result;
};

export const getPlace = async (placeId, uuid) => {
  const result = await axios.post(`${baseAPIRoute}/place`, {
    id: placeId,
    uuid,
  });
  return result;
};

export const getSearchPredictions = async (value, uuid) => {
  const result = await axios.post(`${baseAPIRoute}/search-locations`, {
    text: value,
    uuid,
  });
  return result;
};

export const getNearbyDevelopments = async (coords, greaterThan, limit) => {
  const { lat, lng, distance } = coords;
  const apiRoute = `${baseAPIRoute}/nearby-developments?lat=${lat}&lng=${lng}&distance=${distance}&greaterThan=${greaterThan}${
    limit ? '&limit=3' : ''
  }`;
  const result = await axios(`${apiRoute}`);
  return result;
};
